import { useContext, useState } from "react";
import { colors } from "../utils/colors";
import { FormModal } from "./Forms/LoginModal";
import { UserInfoForm } from "./Forms/UserInfoForm";
import { UserContext } from "../context/user-context/userContext";
import { useFSNavigate } from "@fullstory/react-library";

export const Header = () => {
    // NAVIGATION
    const nav = useFSNavigate();

    // CONTEXT
    const usercontext = useContext(UserContext);
    const { isLoggedIn, logout, navToAccount, userId } = usercontext;

    // STATES
    const [showModal, setShowModal] = useState<boolean>(false);

    const formCallBack = () => {
        navToAccount();
        setShowModal(false);
    };

    const setPromo = () => {
        window.localStorage.setItem("promo_bool", "true");
    };

    return (
        <div className="header-container">
            <div className="header-contents">
                <button
                    style={{ border: "1px solid transparent", backgroundColor: "transparent", cursor: "pointer" }}
                    onClick={() => {
                        logout();
                        setPromo();
                        nav(`/`, "HomePage", { uid: userId });
                    }}
                >
                    <h1 style={{ color: colors.offWhite }}>VR Bank</h1>
                </button>

                {!isLoggedIn && (
                    <button onClick={() => setShowModal(true)} className="login-header-button">
                        <p>
                            <b>Login</b>
                        </p>
                    </button>
                )}
                {isLoggedIn && (
                    <button
                        className="login-header-button"
                        onClick={() => {
                            logout();
                            nav(`/`, "HomePage", { uid: userId });
                        }}
                    >
                        <b>Signout</b>
                    </button>
                )}
            </div>

            <FormModal
                title={"Login"}
                show={showModal}
                close={() => setShowModal(false)}
                Form={<UserInfoForm changeForm={true} formType="login" submitCallback={() => formCallBack()} />}
            />
        </div>
    );
};
